import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React, { memo, useCallback, useState } from 'react';

import { useDebounce } from '~/hooks/useDebounce';
import { useUpdateEffect } from '~/hooks/useUpdateEffect';

interface Props extends Omit<TextFieldProps, 'value' | 'onChange'> {
  initialValue?: string;
  onChange?: (value: string) => void;
}

const Component: React.FC<Props> = ({ sx = [], initialValue = '', onChange, ...props }) => {
  const [value, setValue] = useState(initialValue);
  const debouncedValue = useDebounce(value);

  useUpdateEffect(() => {
    onChange?.(debouncedValue);
  }, [debouncedValue]);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(event => {
    setValue(event.target.value);
  }, []);

  return (
    <TextField
      size="small"
      slotProps={{
        input: {
          sx: {
            height: '36px',
            backgroundColor: 'var(--white-color)',
          },
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon sx={{ color: 'var(--gray-2-color)' }} />
            </InputAdornment>
          ),
        },
      }}
      sx={[{ '& fieldset': { border: 'none' } }, ...(Array.isArray(sx) ? sx : [sx])]}
      value={value}
      variant="outlined"
      onChange={handleChange}
      {...props}
    />
  );
};

export const SearchInput = memo(Component);
